import { IConvertGameList, ISlotConverter } from '../../types/converter';
import { ISlotViewItem } from '../../types/interfaces/Slots/Slots';
import { IGetGameUrl } from '../../types/slot';
import { CasinoType } from 'modules/Casino/types/configuration';
import { getTab, isHiddenGame } from './utils';

class Converter implements ISlotConverter {
  convertGameList = ({
    data,
  }: IConvertGameList<
    Array<{
      uuid: string;
      gameId: number | string;
      gameCategory: string;
      gameName: string;
      title: string;
      image: string;
    }>
  >): ISlotViewItem[] =>
    (data ?? [])
      .filter(game => !isHiddenGame(String(game.gameId)))
      .map(
        game =>
          ({
            id: String(game.uuid ?? game.gameId),
            gameId: String(game.gameId),
            gameName: game.gameName,
            description: game.title || game.gameName,
            routeProvider: 'smartsoft',
            provider: 'smartsoft',
            type: CasinoType.slots,
            tab: getTab(String(game.gameId)),
            imageUrl: game.image,
            gameCategory: game.gameCategory,
          }) as ISlotViewItem,
      );

  convertGameUrl = ({ data }: IGetGameUrl<{ launcher_url: string }, unknown>) => data.launcher_url;
}

export default Converter;
